import script from "./ComparePrint.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComparePrint.vue?vue&type=script&setup=true&lang=ts"

import "./ComparePrint.vue?vue&type=style&index=0&id=c57bb568&lang=css"

const __exports__ = script;

export default __exports__